

export interface IPediatricChild {
    id: string;
    label: string;
    minOld: number;
    observation: string;
    isAlerted: boolean;
    isActivated: boolean;
    order:number;
}

export class PediatricChild implements IPediatricChild {
    id: string;
    label: string;
    minOld: number;
    observation: string;
    isAlerted: boolean;
    isActivated: boolean;
    order: number;
    constructor(other?: Partial<IPediatricChild>) {
        this.id = other?.id || '';
        this.label = other?.label || '';
        this.minOld = other?.minOld || 0;
        this.observation = other?.observation || '';
        this.isAlerted = other?.isAlerted || false;
        this.isActivated = other?.isActivated || false;
        this.order = other?.order || 0;
    }

    static fromResponse(response: any): PediatricChild {
        
        return new PediatricChild({
            id: response.id,
            label: response.label,
            minOld: response.minOld,
            observation: response.observation,
            isAlerted: response.alerted,
            isActivated: response.activated,
            order: response.order
        });
    }

    get requestPayload(): Object {
        return ({
            id: this.id,
            label: this.label,
            minOld: this.minOld,
            observation: this.observation,
            alerted: this.isAlerted,
            activated: this.isActivated,
            orderNumber: this.order
        });
    }
}
